import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import { SwiperSlide } from "swiper/react";

import { ContentItemCard } from "~/components/content/content-item-render/variants/card";
import type { topicSponsorArticlesQueueQuery$key } from "~/queries/__generated__/topicSponsorArticlesQueueQuery.graphql";

import { Container, Header, StyledSwiper } from "./styles";

type Props = {
  className?: string;
  reference: topicSponsorArticlesQueueQuery$key;
};

export const TopicSponsorArticles: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const data = useFragment(
    graphql`
      fragment topicSponsorArticlesQueueQuery on Query
      @argumentDefinitions(sponsorArticleQueueName: { type: "String" }) {
        sponsorArticlesQueue: queue(filter: { name: $sponsorArticleQueueName }) {
          items(first: 20) {
            edges {
              node {
                ... on Base {
                  entityId
                }
                ...cardContentItemContent
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  if ((data.sponsorArticlesQueue?.items?.edges.length ?? 0) < 4) return null;

  return (
    <Container className={className}>
      <Header>FROM OUR ADVERTISERS</Header>
      <StyledSwiper slidesPerView="auto" spaceBetween={20}>
        {data.sponsorArticlesQueue?.items?.edges.map(({ node }) => (
          <SwiperSlide key={node.entityId} style={{ inlineSize: "214px" }}>
            <ContentItemCard reference={node} />
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </Container>
  );
};

TopicSponsorArticles.displayName = "TopicSponsorArticles";
